import ChannelChart from '@op/pages/Overview/KeyMetrics/MentionsSentiment/Channel';
import LanguageChart from '@op/pages/Overview/KeyMetrics/MentionsSentiment/Language';
import React, { useMemo } from 'react';
import { Col, Row } from 'tea-component';
import { useToOpinionPage } from '../../utils';
import './index.scss';
import Abnormal from '@home/components/Abnormal';

function OpinonsChannelLanguge(props: any) {
  const { filter, filterCond, filterLoading } = props;

  // 使用useMemo钩子函数，根据filter属性，生成新的filter对象
  const newFilter = useMemo(() => {
    if (!filter?.date_type || !filterCond) return {};
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    return { 
      ...(restFilter || {}), 
      social_media_by_account: filterCond?.social_media_by_account || undefined, 
      social_media_by_keyword: undefined 
    };
  }, [filter, filterCond]);

  const { goToOtherPage: goChannel } = useToOpinionPage({
    filter,
    key: 'Channel',
  });

  const { goToOtherPage: goLanguage } = useToOpinionPage({
    filter,
    key: 'Language',
  });

  const goToChannel = () => {
    goChannel();
  };

  const goToLanguage = () => {
    goLanguage();
  };

  return (
    <Abnormal
      isLoading={filterLoading}
      classNames={'dbh-studio-opinions-channel-language-abnormal'} component={
        <Row className='dbh-studio-opinions-chanenl-language' >
          <Col span={12}>
            <ChannelChart
              tab={'total'}
              titleClickFunc={goToChannel}
              filter={newFilter}
            />
          </Col>
          <Col span={12}>
            <LanguageChart
              tab={'total'}
              titleClickFunc={goToLanguage}
              filter={newFilter}
            />
          </Col>
        </Row>
      }>
    </Abnormal>
  );
}

export default OpinonsChannelLanguge;
